module.exports = __webpack_public_path__ + "img/logo.db91e691.png";